// extracted by mini-css-extract-plugin
export default {"exerciseRequestForm":"styles_exerciseRequestForm__iBJrA"};